export const apiMomentDateFormat = 'YYYY-MM-DD';
export const apiMomentDateTimeFormat = 'YYYY-MM-DD HH:mm';